export const CONFIG_KEY = "cookieControl";
export const COOKIE_ID_SEPARATOR = "~";
export const LOCALE_DEFAULT = "en";
